import { inject, Injectable } from '@angular/core';
import { Method } from 'eurogard-pattern';
import { UserControllerUpdateRemoteMethod } from 'open-api-legacy/remote-methods/user-controller-update.remote-method';
import { IUserSettingsEditForm } from './user-settings-edit.form';
import { UserControllerUpdateResponse } from 'open-api-legacy/responses/user-controller-update.response';
import {
  UserSettingsAccordionDataSource
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-settings-accordion.data-source';
import { transformDocumentToUpdateMap } from 'eurogard-utilities';

@Injectable()
export class SubmitUserInfoMethod implements Method<UserControllerUpdateResponse, IUserSettingsEditForm> {
  private readonly userSettingsAccordionDataSource = inject(UserSettingsAccordionDataSource);
  private readonly userControllerUpdateRemoteMethod = inject(UserControllerUpdateRemoteMethod);

  call(formValue: IUserSettingsEditForm) {
    const userUuid = this.userSettingsAccordionDataSource.data?.uuid;

    if (!userUuid) {
      return Promise.reject(new Error('User UUID is not defined'));
    }

    return this.userControllerUpdateRemoteMethod.call({
      parameters: {
        uuid: userUuid,
      },
      requestBody: { updateMap: transformDocumentToUpdateMap(formValue) },
    });
  }

}
